import QLVNCabinet from "./QLVNCabinet.vue";
import QLVNCabinetProperties from "./QLVNCabinetProperties.vue";
import QLVNCabinetProperty from "./default.json";

export default {
  install(Vue) {
    Vue.component(QLVNCabinet.name, QLVNCabinet);
    Vue.component(QLVNCabinetProperties.name, QLVNCabinetProperties);
    Vue.prototype.$QLVNCabinetProperties = QLVNCabinetProperty;
  },
};
